<template>
  <v-row>
    <v-col cols="12" sm="7" md="9" class="pr-sm-5">
      <BaseFilter
        v-model="filter"
        :textPlaceholder="'Digite o Registro Susep ou Nome da Seguradora'"
        v-bind="defaultConfigs"
        @search="searchByFilter"
        v-on:keyup="searchByFilterClickEnter"
      />
    </v-col>
    <v-col
      cols="12"
      sm="5"
      md="3"
      class="pb-5 pb-sm-0"
      v-if="canSeeNewInsurance"
    >
      <BaseButton
        class="secondary white--text"
        width="100%"
        :to="{ name: 'new insurance_company' }"
      >
        <v-icon class="pr-2">
          fa-plus
        </v-icon>
        INCLUIR SEGURADORA
      </BaseButton>
    </v-col>
    <v-col cols="12">
      <BaseDataTable
        :headers="header"
        :items="listInsuranceCompany"
        no-data-text="Nenhuma Seguradora foi encontrada"
        loading-text="Carregando Seguradoras..."
        :options.sync="options"
        :server-items-length="totalInsuranceCompany"
        class="insurance-company-table"
        @click:row="editInsuranceCompany"
      >
        <template v-slot:[`item.registro_susep`]="{ item }">
          <div :class="borderColor(item.status)">
            <div class="insurance-company-table__padding">
              {{ item.registro_susep }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.categoria`]="{ item }">
          {{ item.categoria.nome }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          {{ item.status.nome }}
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
const defaultProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const tableHeaders = [
  { text: "Susep", value: "registro_susep", sortable: true },
  { text: "Tipo", value: "categoria", sortable: true },
  { text: "Nome", value: "nome", sortable: true },
  { text: "Status", value: "ativo", sortable: true }
];
const colorByStatus = [
  { color: "green", status: "ATIVO" },
  { color: "pink", status: "INATIVO" }
];
import { mapState, mapActions } from "vuex";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    filter: "",
    header: tableHeaders,
    listColorByStatus: colorByStatus,
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    }
  }),
  mixins: [CommonPayload, LoadingRequest],
  created() {
    this.fetchInsuranceCompany(this.getPayload(this.options, this.filter));
  },
  computed: {
    ...mapState("insuranceCompany", [
      "listInsuranceCompany",
      "totalInsuranceCompany"
    ]),
    ...mapState(["userPermissions"]),
    defaultConfigs() {
      return {
        ...defaultProps
      };
    },
    canSeeNewInsurance() {
      return this.userPermissions.acoes.some(x => x.id == "criar_seguradora");
    },
    canSeeEditInsurance() {
      return this.userPermissions.acoes.some(x => x.id == "editar_seguradora");
    }
  },
  methods: {
    ...mapActions("insuranceCompany", ["requestListInsuranceCompany"]),
    fetchInsuranceCompany(payload) {
      this.withLoading(this.requestListInsuranceCompany(payload));
    },
    borderColor(item) {
      const status = this.listColorByStatus.find(x => x.status == item.nome);
      return `insurance-company-table__border-${status.color}`;
    },
    searchByFilter() {
      this.fetchInsuranceCompany(this.getPayload(this.options, this.filter));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.fetchInsuranceCompany(this.getPayload(this.options, this.filter));
    },
    editInsuranceCompany(item) {
      if (this.canSeeEditInsurance)
        this.$router.push({
          name: "edit insurance_company",
          params: { id: item.id }
        });
    }
  },
  watch: {
    options: {
      handler(value) {
        this.fetchInsuranceCompany(this.getPayload(value, this.filter));
      },
      deep: true
    }
  }
};
</script>
<style lang="sass">
.insurance-company-table__
  &border-green
    border-left: 5px solid #49DCBB
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.insurance-company-table
  tbody tr
    cursor: pointer
.insurance-company-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
